import { Form, Input, Select, App } from 'antd';
import { trpc } from '../../../lib/api';
import { clientTypeOptions } from '../../../lib/clientType';
import { withDevModalFilePath } from '../../../components/common';

const { Modal } = withDevModalFilePath('client/src/pages/admin/partners/CreatePartnerCompanyModal.tsx');

interface CreatePartnerCompanyModalProps {
  open: boolean;
  onCancel: () => void;
  onSuccess: () => void;
}

const statusOptions = [
  { label: '有効', value: 'active' },
  { label: '停止', value: 'inactive' },
];

const billingModelOptions = [
  { label: 'プラットフォーム課金', value: 'platform_billing' },
  { label: '代理店課金', value: 'partner_billing' },
];

export function CreatePartnerCompanyModal({ open, onCancel, onSuccess }: CreatePartnerCompanyModalProps) {
  const { message } = App.useApp();
  const [form] = Form.useForm();

  const createMutation = trpc.partnerAdmin.createCompany.useMutation({
    onSuccess: () => {
      message.success('パートナー会社を作成しました');
      form.resetFields();
      onSuccess();
    },
    onError: (error) => {
      message.error(error.message || '作成に失敗しました');
    },
  });

  const handleSubmit = () => {
    form.validateFields().then((values) => {
      createMutation.mutate(values);
    });
  };

  return (
    <Modal
      title="パートナー会社を作成"
      open={open}
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      onOk={handleSubmit}
      okText="作成"
      cancelText="キャンセル"
      confirmLoading={createMutation.isPending}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{ status: 'active', billingModel: 'platform_billing', clientType: '' }}
      >
        <Form.Item
          name="name"
          label="会社名"
          rules={[{ required: true, message: '会社名を入力してください' }]}
        >
          <Input placeholder="株式会社サンプルパートナー" />
        </Form.Item>
        <Form.Item name="status" label="ステータス">
          <Select options={statusOptions} />
        </Form.Item>
        <Form.Item name="billingModel" label="課金モデル">
          <Select options={billingModelOptions} />
        </Form.Item>
        <Form.Item name="clientType" label="対象クライアント">
          <Select options={clientTypeOptions} />
        </Form.Item>
        <Form.Item name="billingContactEmail" label="請求連絡先メール">
          <Input placeholder="billing@example.com" />
        </Form.Item>
        <Form.Item name="supportEmail" label="サポートメール">
          <Input placeholder="support@example.com" />
        </Form.Item>
      </Form>
    </Modal>
  );
}
